import { Component, computed, inject, signal, WritableSignal } from '@angular/core';
import { MatCheckboxChange, MatCheckboxModule } from '@angular/material/checkbox';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { UiButtonComponent } from '@app/shared/ui/button/ui-button.component';

import { Project } from '@app/shared/types/models/project/project.model';
import { UiDialogComponent } from '@app/shared/ui/dialog/ui-dialog.component';
import { TranslatePipe } from '@ngx-translate/core';

export interface SelectCooperationProjectsDialogData {
  projects: Project[];
}

@Component({
  selector: 'proffeo-select-cooperation-projects-dialog',
  standalone: true,
  imports: [MatDialogModule, TranslatePipe, UiDialogComponent, UiButtonComponent, MatCheckboxModule],
  templateUrl: './select-cooperation-projects-dialog.component.html'
})
export class SelectCooperationProjectsDialogComponent {
  private readonly dialogRef = inject(MatDialogRef<SelectCooperationProjectsDialogComponent, string[]>);

  protected readonly data = inject<SelectCooperationProjectsDialogData>(MAT_DIALOG_DATA);
  protected readonly projects = computed(() => this.data.projects ?? []);

  protected selectedProjectIds: WritableSignal<Set<string>> = signal(new Set<string>());

  protected isSelected(projectId: string): boolean {
    return this.selectedProjectIds().has(projectId);
  }

  protected toggle(projectId: string, event: MatCheckboxChange): void {
    const next = new Set(this.selectedProjectIds());
    if (event.checked) {
      next.add(projectId);
    } else {
      next.delete(projectId);
    }
    this.selectedProjectIds.set(next);
  }

  protected canSave(): boolean {
    return this.selectedProjectIds().size > 0;
  }

  protected save(): void {
    if (!this.canSave()) return;
    this.dialogRef.close(Array.from(this.selectedProjectIds()));
  }
}
